exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  background-color: #fffc00;\n  height: 80px;\n  overflow: hidden;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.header a img {\n  width: 70px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/Header.vue?vue&type=style&index=0&id=1f234af1&lang=stylus
// module id = 215
// module chunks = 6 7 8 9 10